import { onViewAllMenuClicked } from '../actions/internalActions';
import { getStore } from '../store/store';
import { mutator } from 'satcheljs';

/**
 * Subscribes to onViewAllMenuClicked action and mutates moveToSharedFolderRootId
 */
mutator(onViewAllMenuClicked, actionMessage => {
    getStore().moveToSharedFolderRootId = actionMessage.rootFolderId;
});
